import dayjs from "dayjs";

// PORTS OF THE ANGULAR PIPES THE PROFILE CARD USES.

// `date` WITH NO FORMAT (`mediumDate`): "Sep 28, 2026"; EMPTY FOR A MISSING VALUE
export const mediumDate = (v: string | undefined) => (v ? dayjs(v).format("MMM D, YYYY") : "");

// `age`: WHOLE YEARS SINCE THE DATE (`moment().diff(value, "years")`)
export const age = (v: string | undefined, now: Date = new Date()) => dayjs(now).diff(dayjs(v), "year");

// `timeUntil`: DAYS UNTIL THE NEXT ANNIVERSARY OF THE DATE, "Today" ON IT. LIKE THE PIPE IT
// READS THE MONTH AND DAY IN UTC AND COMPARES THEM TO LOCAL "NOW", AND ROUNDS UP.
export function timeUntil(v: string | undefined, now: Date = new Date()): string {
  const d = new Date(v ?? "");
  const next = new Date(now.getFullYear(), d.getUTCMonth(), d.getUTCDate());
  if (now.getMonth() === next.getMonth() && now.getDate() === next.getDate()) return "Today";
  if (now > next) next.setFullYear(now.getFullYear() + 1);
  return "In " + Math.ceil((next.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)) + " days";
}
